function reduceById(state = {}, data = []) {
  return data.reduce(
    (acc, model) => {
      acc[model.id] = model;

      return acc;
    },
    { ...state },
  );
}

function deleteById(state = {}, data = []) {
  return data.reduce(
    (acc, model) => {
      delete acc[model.id];

      return acc;
    },
    { ...state },
  );
}

function updateById(state = {}, data = {}) {
  return {
    ...state,
    [data.id]: data,
  };
}

export { reduceById, updateById, deleteById };
